
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.53 8.47a.75.75 0 010 1.06l-6 6a.75.75 0 01-1.06 0l-6-6a.75.75 0 011.06-1.06L12 13.94l5.47-5.47a.75.75 0 011.06 0z","fill":"currentColor"}})])
          )
        }
      }
    